import { render, staticRenderFns } from "./DetGuiasRegaliasForm.vue?vue&type=template&id=4f4721a0"
import script from "./DetGuiasRegaliasForm.vue?vue&type=script&lang=js"
export * from "./DetGuiasRegaliasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports